import React, { useEffect, useState } from "react";
// import { createChecksum } from "../commonFunctions/fileFolderConfig";
import { useNavigate } from "react-router-dom";
import MaterialIcon from "../components/BuilderComponents/MaterialIcon";
import { useAppBlocksContext } from "../context/AppBlocksContext";
import { useNavigationContext } from "../context/NavigationContext";
import useUnsavedChangesGuard from "../hooks/useUnsavedChangesGuard";
import { hasConfigChanged } from "../utils/configChecksum/configComparer";
import { toastSuccess } from "../utils/toastUtils";
import { getToolTipAttributes } from "../utils/tooltip";

const PageInfoAndActionBar = ({
  pagePath,
  clonePage,
  savePage,
  // currentConfig = [],
  // pageName,
  saveOwner,
  saveTemplate,
  showSaveTemplate = false,
  previewPage,
  importSomething,
  settingPage,
  jsonPage,
  customFunc,
  toggleLock,
  toggleFullLock,
  toggleSelectedLock,
  isLocked,
  notesPage,
  selected
}) => {
  // const [isSave, setIsSave] = useState(true);
  const [isInitialConfigDiffrent, setIsInitialConfigDiffrent] = useState(false);
  const { getPageInfoAndPath } = useNavigationContext();
  const { lockData } = useAppBlocksContext();
  const [sourcePath, setSourcepath] = useState({});
  const { isChange, onChangeStatus } = useUnsavedChangesGuard();
  const [isSaving, setIsSaving] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const { getCurrentPageConfigFunction, saveCurrentPageConfig } = useNavigationContext();
  // const isFirstTime = useRef(true);
  const navigate = useNavigate();
  const handlePageSave = async () => {
    try {
      setIsSaving(true); // disable the button
      const { message } = await savePage();
      onChangeStatus(false);
      setIsInitialConfigDiffrent(false);
      toastSuccess(message);
    } catch (error) {
      console.log(error, "pageInfoActionBar");
    } finally {
      setIsSaving(false); // re-enable the button
    }
  };

  // const changeDepedencies = async () => {
  //   try {
  //     const config = await getCurrentPageConfigFunction(pageName);
  //     const newChecksum = createChecksum(config);
  //     // console.log("from page", newChecksum, config);
  //     if (newChecksum === currentChecksum.current) {
  //       setIsSave(true);
  //     } else {
  //       // if (isFirstTime.current) {
  //       //   isFirstTime.current = false;
  //       //   await saveCurrentPageConfig();
  //       //   setIsSave(true);
  //       // } else {
  //       setIsSave(false);
  //       // }
  //     }
  //     isFirstTime.current = false;
  //   } catch (error) {
  //     console.log("Something went wrong", error);
  //   }
  // };

  // const changeDepedencies = async () => {
  //   try {
  //     const newConfig = await getCurrentPageConfigFunction(pageName);
  //     // const newChecksum = createChecksum(newConfig);
  //     // const { config } = getModifiedChecksum();
  //     const hasConfigChange = hasChecksumChangedWithModified(newConfig);
  //     // const diff = getObjectDifference(config, newConfig);
  //     if (!hasConfigChange) {
  //       setIsSave(true);
  //       const hasChecksumChange = hasChecksumChanged();
  //       if (hasChecksumChange) {
  //         // const comp = comparedChecksumConfig();
  //         // console.log("compared from initla pageaction bar", comp);
  //         setIsInitialConfigDiffrent(true);
  //       }
  //     } else {
  //       // if (isFirstTime.current) {
  //       //   isFirstTime.current = false;
  //       //   await saveCurrentPageConfig();
  //       //   setIsSave(true);
  //       // } else {
  //       setIsSave(false);
  //       setIsInitialConfigDiffrent(false);
  //       // }
  //     }
  //     isFirstTime.current = false;
  //   } catch (error) {
  //     console.log("Something went wrong", error);
  //   }
  // };
  // useEffect(() => {
  //   changeDepedencies();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [...currentConfig]);

  useEffect(() => {
    const getPageInfo = async () => {
      const sourceAndPath = await getPageInfoAndPath();
      setSourcepath(sourceAndPath);
    };
    getPageInfo();

    const hasChecksumChange = hasConfigChanged();
    if (hasChecksumChange) {
      // const comp = comparedChecksumConfig();
      // const { checksum } = getInitialChecksum();
      // const { checksum: newChecksum } = getModifiedChecksum();
      setIsInitialConfigDiffrent(true);
    } else {
      setIsInitialConfigDiffrent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClone = async () => {
    try {
      const pathId = await clonePage();
      navigate(`../${pathId}`);
      toastSuccess("record cloned successfully");
    } catch (error) {
      console.log(error, "PageInfoActionBar");
    }
  };

  return (
    <div className="screen_save_container">
      {pagePath && (
        <div className="header_section_heading">
          <div className="d_flex align_center">
            {pagePath.split("/").map((part, index, arr) => (
              <div key={index} className="d_flex align_center">
                <span>{part}</span>

                {index < arr.length - 1 && (
                  <MaterialIcon name="chevron_right" style={{ verticalAlign: "middle", marginTop: "2px" }} />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      <div
        className="blocks_source"
        // onClick={() => navigate(sourcePath.path)}
      >
        {sourcePath?.source}
      </div>
      <div className="save_block">
        {customFunc && (
          <MaterialIcon
            name="code_blocks"
            className="screen_top_icons"
            {...getToolTipAttributes("JS and Css", "bottom")}
            onClick={customFunc}
          />
        )}
        {saveOwner && (
          <MaterialIcon
            name="group"
            className="screen_top_icons"
            {...getToolTipAttributes("Owner Assignment", "bottom")}
            onClick={() => saveOwner(true)}
          />
        )}
        {toggleLock && (
          <MaterialIcon
            name={isLocked ? "lock" : "lock_open"}
            className={`screen_top_icons ${isLocked ? "locked" : "unlocked"}`}
            style={{ color: isLocked ? "red" : "" }}
            onClick={toggleLock}
            {...getToolTipAttributes(isLocked ? `Locked by ${lockData.user_info}` : "Lock", "bottom")}
          />
        )}
        {toggleFullLock && (
          <MaterialIcon
            name={isLocked ? "lock" : "lock_open"}
            className={`screen_top_icons ${isLocked ? "locked" : "unlocked"}`}
            onClick={toggleFullLock}
            {...getToolTipAttributes(selected ? "Release Lock" : "Lock", "bottom")}
          />
        )}
        {toggleSelectedLock && (
          <MaterialIcon
            name={selected ? "lock" : "lock_open"}
            className={`screen_top_icons ${selected ? "locked" : "unlocked"}`}
            onClick={toggleSelectedLock}
            {...getToolTipAttributes(selected ? "Release Lock" : "Lock", "bottom")}
          />
        )}
        {previewPage && (
          <MaterialIcon
            name="preview"
            className="screen_top_icons"
            {...getToolTipAttributes("Preview", "bottom")}
            onClick={previewPage}
          />
        )}
        {importSomething && (
          <MaterialIcon
            name="download"
            className="screen_top_icons"
            {...getToolTipAttributes("Download", "bottom")}
            onClick={importSomething}
          />
        )}
        {notesPage && (
          <MaterialIcon
            name="notes"
            className="screen_top_icons"
            {...getToolTipAttributes("Notes and Tags", "bottom")}
            onClick={notesPage}
          />
        )}
        {clonePage && (
          <MaterialIcon
            name="content_copy"
            className="screen_top_icons"
            {...getToolTipAttributes("Clone", "bottom")}
            onClick={handleClone}
          />
        )}
        {settingPage && (
          <MaterialIcon
            name="settings"
            className="screen_top_icons"
            {...getToolTipAttributes("Settings", "bottom")}
            onClick={settingPage}
          />
        )}
        {jsonPage && (
          <MaterialIcon
            name="data_object"
            className="screen_top_icons"
            {...getToolTipAttributes("Json", "bottom")}
            onClick={jsonPage}
          />
        )}
        {showSaveTemplate && (
          <MaterialIcon
            name="upload_file"
            className="screen_top_icons"
            {...getToolTipAttributes("Save Template", "bottom")}
            onClick={saveTemplate}
          />
        )}

        {savePage && (
          <div className="position_relative">
            <MaterialIcon
              name="save"
              className={`screen_top_icons ${isChange && "save_glowing"} ${isSaving && "disabled"}`}
              onClick={isSaving ? undefined : handlePageSave}
              style={{ opacity: isSaving ? 0.5 : 1, pointerEvents: isSaving ? "none" : "auto" }}
              {...getToolTipAttributes(isSaving ? "Saving..." : "Save", "bottom")}
            />
            {isInitialConfigDiffrent && !isSaving && (
              <span className="unsaved_tooltip">
                <span className="tooltip_arrow"></span>
                Unsaved Changes
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageInfoAndActionBar;
